import Drawer from '@/common/components/Drawer/Drawer';
import { Dispatch, SetStateAction } from 'react';
import UserInfo from './UserInfo';
import ManageSettings from './ManageSettings';
import LogoutButton from '../LogoutButton/LogoutButton';
import { Box } from '@mui/material';
import { lelyTokenPrimitives } from '@/common/styles/newStyles/LelyMuiTheme';
import { useLelyAuth } from '@/auth/useLelyAuth';
const t = lelyTokenPrimitives as Record<string, string>;

type Props = {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
};

const UserSettings = ({ open, setOpen }: Props) => {
  const { user } = useLelyAuth();

  return (
    <Drawer open={open} title="User settings" onClose={() => setOpen(false)}>
      <Box
        display="flex"
        flexDirection="column"
        flex={1}
        minHeight={0}
        alignSelf="stretch"
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap={t.spaceXs}
          flex={1}
        >
          <UserInfo />
          {user?.allowltda && (
            <ManageSettings onCloseUserSettings={() => setOpen(false)} />
          )}
        </Box>
        <Box
          component="footer"
          sx={{
            display: 'flex',
            flexShrink: 0,
            mt: 'auto',
            mx: `-${t.spaceLg}`,
            mb: `-${t.spaceSm}`,
            p: t.spaceLg,
            backgroundColor: t.backgroundColorLight,
          }}
        >
          <LogoutButton />
        </Box>
      </Box>
    </Drawer>
  );
};
export default UserSettings;
